import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

import { Modal, ModalBody, Button } from "reactstrap";

import { ThemeContext } from "contextProviders/ThemeProvider";

import { Api } from "api";
import { logoutSuccess } from "actions";
//notifications
import { NotificationManager } from "react-notifications";

const LogoutModal = (props) => {
  const theme = useContext(ThemeContext);
  const [fetching, setFecthing] = useState(false);
  const dispatch = useDispatch();

  const onLogout = async () => {
    try {
      setFecthing(true);
      await Api().get("/auth/users/signout");
      setFecthing(false);
      dispatch(logoutSuccess());
      sessionStorage.clear();
      localStorage.clear();
      dispatch(push("/auth"));
    } catch (error) {
      setFecthing(false);
      NotificationManager.error(
        error?.message ||
          (error?.result?.length > 0 &&
            error.result.map((item) => item.message)),
        false,
        10000
      );
    } finally {
      setFecthing(false);
      dispatch(logoutSuccess());
      sessionStorage.clear();
      localStorage.clear();
      dispatch(push("/auth"));
    }
  };

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={() => {
        if (!fetching) {
          props.onCloseModal();
        }
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title">Déconnexion</h5>
        <button
          onClick={(e) => {
            if (!fetching) {
              props.onCloseModal();
            }
          }}
          aria-label="Close"
          className="close"
          type="button"
        >
          {/* <img
            src={require("assets/img/iconCloseModal.png")}
            className=""
            width="22px"
            alt=">"
          /> */}
        </button>
      </div>
      <ModalBody>
        <p>Êtes-vous sûr de vouloir vous déconnecter ?</p>
      </ModalBody>
      <div className="modal-footer logout">
        <Button
          disabled={fetching}
          className="btn-round logout"
          color="default"
          type="button"
          onClick={onLogout}
        >
          Oui
        </Button>
        <Button
          disabled={fetching}
          className={`btn-round logout ${theme}`}
          onClick={(e) => {
            e.preventDefault();
            props.onCloseModal();
          }}
          color="secondary"
          type="button"
        >
          Non
        </Button>
      </div>
    </Modal>
  );
};

export default LogoutModal;
